import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import legolasApi from '../../api/legolas';
import {
  Box,
  Typography,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Snackbar,
  Alert,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Grid,
} from '@mui/material';
import Rating from '@mui/material/Rating';

const WinterOrderDetail = () => {
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    axios
      .get(`${legolasApi.url}/orders/detailview/winterorder/${orderId}`)
      .then((response) => {
        console.log('API Response:', response.data);
        setOrderDetails(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching order details:', error);
      });
  }, [orderId]);


  const renderSiblingDetailsTable = (orderDetails) => {
    if (!orderDetails || orderDetails.length === 0) {
      return null;
    }
  
    const headers = [
      'Fullname',
      'Gender',
      // 'Sibling Guardian Name',
      'Phone Number',
      'Email',
      'Educational Level',
      'Program',
    ];
  
    return (
      <TableContainer component={Paper} sx={{ marginTop: '20px', width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: 'bold',
                    backgroundColor: '#2b3f7a',
                    color: 'white',
                    border: '1px solid #ffff',
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {orderDetails.map((order, index) => (
              <TableRow key={index}>
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.full_name}</TableCell>
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.sibling_gender}</TableCell>
                {/* <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.sibling_guardian_name}</TableCell> */}
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.sibling_phone}</TableCell>
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.sibling_email}</TableCell>
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.educational_level}</TableCell>
                <TableCell sx={{ border: '1px solid #2b3f7a' }}>{order.program}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  
  

  const renderOrderDetailsTable = () => {
    if (!orderDetails || orderDetails.length === 0) {
      return null;
    }

    const formatDateAndTime = (inpDate) => {
      const month = inpDate.toLocaleDateString('default', { month: 'short' });
      const date = inpDate.getDate();
      const year = inpDate.getFullYear();
      const formattedTime =
        inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds();
      return `${month} ${date}, ${year} ${formattedTime}`;
    };
    
    const firstOrder = orderDetails[0];

    const isPaymentFailed = firstOrder.order_status !== 2 && ![6, 7].includes(firstOrder.order_status);

    const paymentDescription = isPaymentFailed
    ? firstOrder.responseInfo ? JSON.parse(firstOrder.responseInfo).result.description : 'Unknown reason'
    : '';

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>

        {isPaymentFailed && (
          <Typography variant="h5" sx={{ color: 'red', marginBottom: '20px', marginTop: '10px' }}>
            Payment Failed Reason: {paymentDescription}
          </Typography>
        )}

          <Box sx={{ display: 'flex', marginTop: '10px' }}>
          <Box sx={{ marginRight: '20px', flex: 1 }}>

      <TableContainer component={Paper} sx={{ marginTop: '30px', marginRight: '60px', width: 'auto' }}>
      <Table>
          <TableBody>
             <React.Fragment key={firstOrder.order_id}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Order ID</TableCell>
                    <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.order_id}</TableCell>
                  </TableRow>
                  <TableRow >
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Order Status</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>
                      {firstOrder.order_status === 2 ? 'Payment Sucessfull' : [6,7].includes(firstOrder.order_status) ? 'Dropped Registration' : 'Payment Failed'}
                </TableCell>
                </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Parent Email</TableCell>
                    <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.parent_email}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Parent Name</TableCell>
                    <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.parent_name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Parent Phone Number</TableCell>
                    <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.parent_phone.length > 15 ? `${firstOrder.parent_phone.slice(0, 15)}...` : firstOrder.parent_phone}</TableCell>
                  </TableRow>
      </React.Fragment>
      </TableBody>
        </Table>
      </TableContainer>
      </Box>


      <Box sx={{ flex: 1 }}>
      <TableContainer component={Paper} sx={{ marginTop: '30px', width: 'auto' }}>
      <Table>
        
          <TableBody>
             <React.Fragment key={firstOrder.order_id}>
                <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Parent Relationship</TableCell>
                    <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.parent_relationship}</TableCell>
                </TableRow>
                
                 <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Total Children Count</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.total_sibling_count}</TableCell>
                </TableRow>

                {/* <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Coupon Code</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.coupon_code ? firstOrder.coupon_code:'N/A'}</TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Grand Total</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.grand_total}</TableCell>
                  </TableRow>
                {/* <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Discount Amount</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>{firstOrder.discount_amount}</TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Created At</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>{formatDateAndTime(new Date(firstOrder.oh_created_at))}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', border: '1px solid #2b3f7a' }}>Payment Method</TableCell>
                  <TableCell sx={{ border: '1px solid #2b3f7a' }}>     
                  {firstOrder.fk_payment_id === 4 ? 'MADA' : firstOrder.fk_payment_id === 2 ? 'Credit & Debit Card' : 'N/A'}
                  </TableCell>
                </TableRow>
                
              </React.Fragment>
          </TableBody>
        </Table>
      </TableContainer>
      </Box>
      </Box>
      </Box>
    );
  };

  const handleAlertGen = () => {
    setOpenAlert(true);
  };

  const closeAlert = () => {
    setOpenAlert(false);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        backgroundColor: '#fff',
        margin: '0px 20px',
      }}
    >
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={closeAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={closeAlert}
          severity="success"
          sx={{ width: '400px', marginTop: '100px' }}
        >
          Order Successfully Approved!
        </Alert>
      </Snackbar>

      <Box
        sx={{
          margin: '50px',
          paddingLeft: '20px',
        }}
      >
        <BottomNavigation showLabels sx={{ marginBottom: '20px', justifyContent: 'flex-end' }}>
          <BottomNavigationAction
            label="Back"
            sx={{
              backgroundColor: '#2b3f7a !important',
              border: '1px solid #2b3f7a !important',
              color: '#fff !important',
              '& .Mui-selected': {
                color: '#fff !important',
              },
            }}
            onClick={() => {
              window.history.back();
            }}
          />
        </BottomNavigation>

        <Typography
          variant="h4"
          sx={{ marginBottom: '20px'}}
        >
          Winter Camp Order Details:
        </Typography>
        {renderOrderDetailsTable(orderDetails)}

        <Typography
          variant="h5"
          sx={{ marginTop: '20px'}}
        >
          Children Details:
        </Typography>
        {renderSiblingDetailsTable(orderDetails)}

      </Box>
    </Box>
  );
};

export default WinterOrderDetail;
